import EachSymbolShape, {
  symbolShapePropTypes,
  symbolShapeBaseDefaults,
} from "./EachSymbolShape";

// Cross shape definition (from ChartIQ) — config sobre EachSymbolShape
const CROSS_DIMENSION = [7, 7];

// Cross path centered at origin
// Original ChartIQ path: M 1,0 L 3,2 L 5,0 L 6,1 L 4,3 L 6,5 L 5,6 L 3,4 L 1,6 L 0,5 L 2,3 L 0,1 L 1,0
const getCrossPath = ([w, h]) => {
  const cx = (w - 1) / 2; // 3
  const cy = (h - 1) / 2; // 3
  return `M ${1 - cx},${0 - cy} L ${3 - cx},${2 - cy} L ${5 - cx},${0 - cy} L ${6 - cx},${1 - cy} L ${4 - cx},${3 - cy} L ${6 - cx},${5 - cy} L ${5 - cx},${6 - cy} L ${3 - cx},${4 - cy} L ${1 - cx},${6 - cy} L ${0 - cx},${5 - cy} L ${2 - cx},${3 - cy} L ${0 - cx},${1 - cy} Z`;
};

class EachCross extends EachSymbolShape {}

EachCross.propTypes = symbolShapePropTypes;

EachCross.defaultProps = {
  ...symbolShapeBaseDefaults,
  dimension: CROSS_DIMENSION,
  getPath: getCrossPath,
  stroke: { color: "#2196F3", width: 2, opacity: 1, dash: "Solid" },
  fill: { color: "#2196F3", opacity: 0.6 },
};

export default EachCross;
